(function () {
  const OPEN_BODY_CLASS = 'password-hero-modal-open';

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.body.classList.add(OPEN_BODY_CLASS);
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function syncBodyClass() {
    const anyOpen = document.querySelector('.password-hero__dialog[open]');
    document.body.classList.toggle(OPEN_BODY_CLASS, Boolean(anyOpen));
  }

  // Clicking the backdrop of a native dialog reports the dialog itself as the
  // target, so compare against its box to tell backdrop from panel padding.
  function clickedOutsidePanel(dialog, event) {
    const rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  }

  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-password-hero-open]');
    if (opener) {
      event.preventDefault();
      opener.blur();
      openDialog(document.getElementById(opener.getAttribute('data-password-hero-open')));
      return;
    }

    const closer = event.target.closest('[data-password-hero-close]');
    if (closer) {
      event.preventDefault();
      closeDialog(closer.closest('dialog'));
      return;
    }

    const dialog = event.target.closest('.password-hero__dialog');
    if (dialog && event.target === dialog && clickedOutsidePanel(dialog, event)) {
      closeDialog(dialog);
    }
  });

  document.addEventListener('close', syncBodyClass, true);

  function autoOpen(root) {
    const trigger = (root || document).querySelector('[data-password-hero-autoopen]');
    if (trigger) openDialog(trigger.closest('.password-hero__dialog'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoOpen();
    });
  } else {
    autoOpen();
  }

  document.addEventListener('shopify:section:load', function (event) {
    autoOpen(event.target);
  });
})();
